export default __webpack_public_path__ + "static/media/farmMap.0d7852aa.png";